// 3_pages/product_reviews.js
// On product pages, moves the rate form into the rating tab, adds a reviews heading,
// and makes the star rating scroll to the rating tab on click.

export function init() {
	if (!document.body.classList.contains("type-product")) return;

	productReviews();
}

function productReviews() {
	const ratingTab = document.querySelector("#ratingTab");
	const rateForm = document.querySelector("#rate-form");
	const rateWrap = document.querySelector("#ratingTab .rate-wrap");

	if (!ratingTab || !rateForm || !rateWrap) return;

	rateWrap.appendChild(rateForm);

	const rateAverageWrap = ratingTab.querySelector(".rate-average-wrap");
	if (rateAverageWrap) {
		const ratingHeader = document.createElement("h3");
		ratingHeader.classList.add("rating-header");
		ratingHeader.textContent = window.NAT.translations("reviewsTitle");
		rateAverageWrap.prepend(ratingHeader);
	}

	const starsWrapper =
		document.querySelector(".product-top .stars-wrapper") ||
		document.querySelector(".p-detail-inner-header .stars-wrapper");

	if (starsWrapper) {
		starsWrapper.addEventListener("click", function (event) {
			event.preventDefault();
			window.NAT.utils.scrollToElement(ratingTab);
		});
	} else {
		console.warn("Stars wrapper not found on product page.");
	}
}
